import { Component, Input } from '@angular/core'; 
import { GeneralHistoryModel } from '../../../web-api-client';

@Component({
  selector: 'app-general-history',
  templateUrl: './general-history.component.html',
  styleUrls: ['./general-history.component.scss']
})
export class GeneralHistoryComponent {
  @Input() history: GeneralHistoryModel[] = [];
}
